import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { Table, TableHead, TableRow, TableHeaderCell, TableBody, TableCell } from 'react-magma-dom';
import { LeadParagraph } from '../../components/LeadParagraph';
export const _frontmatter = {
  "pageTitle": "Spacing Design Guidelines",
  "title": "Spacing",
  "order": 2
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

<PageContent componentName="spacing" type="design_intro" mdxType="PageContent">
<LeadParagraph mdxType="LeadParagraph">
  Spacing is a powerful visual design tool for creating clearly organized and
  harmonious interfaces.
</LeadParagraph>
<h2>{`Spacing Scale`}</h2>
<p>{`The React Magma spacing scale is based on the 8px grid system with some more granular increments at the smaller end of the scale for more fine-tuned spacing. Spacing can be applied using margin or padding.`}</p>
<p>{`The spacing scale helps us determine how much space to put between or inside of everything you see. This includes large things like the gutters of our page layouts or the padding inside a card component, as well as the tiny space between a label and its corresponding input.`}</p>
<Table mdxType="Table">
  <TableHead mdxType="TableHead">
    <TableRow mdxType="TableRow">
      <TableHeaderCell mdxType="TableHeaderCell">Property</TableHeaderCell>
      <TableHeaderCell mdxType="TableHeaderCell">em</TableHeaderCell>
      <TableHeaderCell mdxType="TableHeaderCell">px</TableHeaderCell>
      <TableHeaderCell width={200} mdxType="TableHeaderCell">Example</TableHeaderCell>
    </TableRow>
  </TableHead>
  <TableBody mdxType="TableBody">
    <TableRow mdxType="TableRow">
      <TableCell mdxType="TableCell">spacing01</TableCell>
      <TableCell mdxType="TableCell">0.125</TableCell>
      <TableCell mdxType="TableCell">2px</TableCell>
      <TableCell width={200} mdxType="TableCell">
        <span className="space-example se-01"></span>
      </TableCell>
    </TableRow>
    <TableRow mdxType="TableRow">
      <TableCell mdxType="TableCell">spacing02</TableCell>
      <TableCell mdxType="TableCell">0.25</TableCell>
      <TableCell mdxType="TableCell">4px</TableCell>
      <TableCell width={200} mdxType="TableCell">
        <span className="space-example se-02"></span>
      </TableCell>
    </TableRow>
    <TableRow mdxType="TableRow">
      <TableCell mdxType="TableCell">spacing03</TableCell>
      <TableCell mdxType="TableCell">0.5</TableCell>
      <TableCell mdxType="TableCell">8px</TableCell>
      <TableCell width={200} mdxType="TableCell">
        <span className="space-example se-03"></span>
      </TableCell>
    </TableRow>
    <TableRow mdxType="TableRow">
      <TableCell mdxType="TableCell">spacing04</TableCell>
      <TableCell mdxType="TableCell">0.75</TableCell>
      <TableCell mdxType="TableCell">12px</TableCell>
      <TableCell width={200} mdxType="TableCell">
        <span className="space-example se-04"></span>
      </TableCell>
    </TableRow>
    <TableRow mdxType="TableRow">
      <TableCell mdxType="TableCell">spacing05</TableCell>
      <TableCell mdxType="TableCell">1</TableCell>
      <TableCell mdxType="TableCell">16px</TableCell>
      <TableCell width={200} mdxType="TableCell">
        <span className="space-example se-05"></span>
      </TableCell>
    </TableRow>
    <TableRow mdxType="TableRow">
      <TableCell mdxType="TableCell">spacing06</TableCell>
      <TableCell mdxType="TableCell">1.5</TableCell>
      <TableCell mdxType="TableCell">24px</TableCell>
      <TableCell width={200} mdxType="TableCell">
        <span className="space-example se-06"></span>
      </TableCell>
    </TableRow>
    <TableRow mdxType="TableRow">
      <TableCell mdxType="TableCell">spacing07</TableCell>
      <TableCell mdxType="TableCell">1.75</TableCell>
      <TableCell mdxType="TableCell">28px</TableCell>
      <TableCell width={200} mdxType="TableCell">
        <span className="space-example se-07"></span>
      </TableCell>
    </TableRow>
    <TableRow mdxType="TableRow">
      <TableCell mdxType="TableCell">spacing08</TableCell>
      <TableCell mdxType="TableCell">2</TableCell>
      <TableCell mdxType="TableCell">32px</TableCell>
      <TableCell width={200} mdxType="TableCell">
        <span className="space-example se-08"></span>
      </TableCell>
    </TableRow>
    <TableRow mdxType="TableRow">
      <TableCell mdxType="TableCell">spacing09</TableCell>
      <TableCell mdxType="TableCell">2.5</TableCell>
      <TableCell mdxType="TableCell">40px</TableCell>
      <TableCell width={200} mdxType="TableCell">
        <span className="space-example se-09"></span>
      </TableCell>
    </TableRow>
    <TableRow mdxType="TableRow">
      <TableCell mdxType="TableCell">spacing10</TableCell>
      <TableCell mdxType="TableCell">3</TableCell>
      <TableCell mdxType="TableCell">48px</TableCell>
      <TableCell width={200} mdxType="TableCell">
        <span className="space-example se-10"></span>
      </TableCell>
    </TableRow>
    <TableRow mdxType="TableRow">
      <TableCell mdxType="TableCell">spacing11</TableCell>
      <TableCell mdxType="TableCell">3.5</TableCell>
      <TableCell mdxType="TableCell">56px</TableCell>
      <TableCell width={200} mdxType="TableCell">
        <span className="space-example se-11"></span>
      </TableCell>
    </TableRow>
    <TableRow mdxType="TableRow">
      <TableCell mdxType="TableCell">spacing12</TableCell>
      <TableCell mdxType="TableCell">4</TableCell>
      <TableCell mdxType="TableCell">64px</TableCell>
      <TableCell width={200} mdxType="TableCell">
        <span className="space-example se-12"></span>
      </TableCell>
    </TableRow>
    <TableRow mdxType="TableRow">
      <TableCell mdxType="TableCell">spacing13</TableCell>
      <TableCell mdxType="TableCell">6</TableCell>
      <TableCell mdxType="TableCell">96px</TableCell>
      <TableCell width={200} mdxType="TableCell">
        <span className="space-example se-13"></span>
      </TableCell>
    </TableRow>
    <TableRow mdxType="TableRow">
      <TableCell mdxType="TableCell">spacing14</TableCell>
      <TableCell mdxType="TableCell">10</TableCell>
      <TableCell mdxType="TableCell">160px</TableCell>
      <TableCell width={200} mdxType="TableCell">
        <span className="space-example se-14"></span>
      </TableCell>
    </TableRow>
  </TableBody>
</Table>
<span className="horizontal-spacer"></span>
<figure>{`
  `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "61.77606177606177%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAIAAADtbgqsAAAACXBIWXMAAAsTAAALEwEAmpwYAAABqUlEQVQoz4WRTUsbURSG8wfcSdf+BXFXSttFQYiCyxQCpVJqF2I2rswui9bYgNqISqGbLqpEjAt15cpFoW7S0qD9ANNkZu583Jnxzr1z7z2TTDKmJLpIwJjDuzlwnvP1xmR/AICiot9VtazUflQvkWWqSkVX/9m2ARBIKXqLY70J5/z6OppOvnnwKD6WeDWRfptez6ZeTOZSU8Xd1VbU5twfAscTL0cexhNLK+ntwqfdo3xmPjv35HhvozkUbreaz+YWY+OPR5OzM+/z+Y+fM6nny6+fnuxvD4GFEGGjnlvbWVh6t7i29aF4ePb1+0nhS3Fz/fTgqBlFQgy+WXYfgn+ZTg1Tk7T8BnjQEM3Qj65qxMY285jgYiAshbRqGGnIME2EkK7rNsZRGFLsuaZLDMIZl3AnLCQEoP3UjD+Gf+VTTJnDiOmdlwxHJdjEnuPdO1lKraxZilXn9VCGLQh9EqzmShffFIIdV3cFuxc2/hrUpsQiN/KwZ6sOrmBLs1zkDFwbAKhL9SpihMkAOkVdQR2CRiC46JBi8Lc55cxhPvX7Ley4eNurx6r/MZZ6LHF3aKMAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "icon text balance correct",
            "title": "icon text balance correct",
            "src": "/version/4.1.1/static/6d7854fed04b32d4e4f47b3a7663a11e/e3189/icon-text-balance-correct.png",
            "srcSet": ["/version/4.1.1/static/6d7854fed04b32d4e4f47b3a7663a11e/a2ead/icon-text-balance-correct.png 259w", "/version/4.1.1/static/6d7854fed04b32d4e4f47b3a7663a11e/6b9fd/icon-text-balance-correct.png 518w", "/version/4.1.1/static/6d7854fed04b32d4e4f47b3a7663a11e/e3189/icon-text-balance-correct.png 1035w", "/version/4.1.1/static/6d7854fed04b32d4e4f47b3a7663a11e/aa440/icon-text-balance-correct.png 1500w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>{`
  `}<figcaption parentName="figure">{`
    Example of using spacing properties to add padding inside a card, as well as
    the margins between the content within the card.
  `}</figcaption>
</figure>
<span className="horizontal-spacer"></span>
<figure>{`
  `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.79536679536679%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAACkklEQVQoz32SXUiTURzG37pW77qoIOqiMjURDGckTmmzVFgfaMNMpdlU/LpwW2aWn2ElmjYjzSZbSipJBX3QRQQSUtBFEUh5Yy2nbe58vB/nvK/b3Psu3k20i+i5eHjO//CDh/M/jPhfQQAwwrEsSdLWRTQym0cqijQqdR4NhCe+RR9cBkSUiCTyhI9BAiFEIJRQFSaERBS5saUtMTNXozekZOenags0OkOyVm8zdZovXj3RYMu2tBoGhuyPhntaqh7bLRNd/Tfrx1RYEIRIJJJ/tpRh4pj4XQeTUnfvS2TidjLb480mq1Z/LiFDX1h3rf7u5KDD1dVo7KnKmrrX21ba/w/4eEpK8t79KrwtwVxpyS2pY47mHa6/bLY7hh2Tt61lfbW6ZyODRq1xo7Yiy41X2g9l5mbmGVKzC9JyCjV6Q/IxXXfHQE2HPaOkIstqa3C6Xr5+87C3xdHT8GrcVXSqaOPBKKVra2s8x/M8H4lJUY37zfGA4wWORNttCi1hAQlbMKXU7/cDAPxRQYjCioKWMV7FAAIIIYiKxViJKOgXxH78F0woAAAhpDpEEMLQeohdYbEPIwwRRACojhBaD6+jJcRDntnYviQGgkEi0bAcjhULhmT76Py3zyvqfimRZTk25/jgwPC8e2FVYDkVZlkWI+T55EZuwHs5EUgSFAM4sPid83z18ksogGkQi0FEQyyVAPkxv+r54sFuwAhY8C16WS9yDk3PfVh4OjPTbGmyWbsrSky15sqxvtHrndOny28bq4fKbRMXLOOVrU9qbryYcM69ff+Tif3aUCj4fPZj2+CDkXGXsez8yWKTRqtLS0/qaG4vNt/ZkVG9J8d24Myt9EtjOU0zR6qn+u+/G3HO/gHsJDdwfxE0VgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "spacing example",
            "title": "spacing example",
            "src": "/version/4.1.1/static/2890580da1c3b76cb698203e2dc57856/e3189/spacing-example.png",
            "srcSet": ["/version/4.1.1/static/2890580da1c3b76cb698203e2dc57856/a2ead/spacing-example.png 259w", "/version/4.1.1/static/2890580da1c3b76cb698203e2dc57856/6b9fd/spacing-example.png 518w", "/version/4.1.1/static/2890580da1c3b76cb698203e2dc57856/e3189/spacing-example.png 1035w", "/version/4.1.1/static/2890580da1c3b76cb698203e2dc57856/aa440/spacing-example.png 1500w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>{`
  `}<figcaption parentName="figure">{`
    Example of using spacing properties to create the space between cards in a
    grid.
  `}</figcaption>
</figure>
<hr></hr>
<h2>{`Designing with Space`}</h2>
<p>{`Every part of a UI should be intentional including the empty space between elements. The amount of space between items creates relationships and hierarchy.`}</p>
<h3>{`Creating Relationships`}</h3>
<p>{`When elements in a design are close to each other, then they are seen as related. This relationship becomes weaker as the space between them increases.`}</p>
<p>{`Using space to arrange related elements into groups can help you create sections on a page without using lines as a divider.`}</p>
<h3>{`Creating Hierarchy`}</h3>
<p>{`You can give more importance to elements by increasing the space around them. Elements that are close to each other often get grouped together or are viewed as being equally important to each other. Therefore, if you have an element or content of high importance on the page, consider giving it extra surrounding space to help it attract focus.`}</p>
<h3>{`White Space`}</h3>
<p>{`Empty space — also known as white space — is important in design. It can be used to break up sections on a page or to help create focus on certain elements. White space helps with information processing; too much dense information can be disorienting or overwhelming for a user. Sections of a UI are allowed to be dense, but the whole page should not be crowded; there should be white space to let the user’s eye rest.`}</p>
<hr></hr>
<h2>{`FAQ`}</h2>
<p><strong parentName="p">{`Are spacing increments outside of the scale allowed?`}</strong><br />{`
There are always exceptions to the rule, but deviating from the spacing scale should be avoided whenever possible.`}</p>
<p><strong parentName="p">{`Can I still use percentages for spacing?`}</strong><br />{`
Percentages like 50% (1/2) or 33% (1/3) are still acceptable ways to divide a page. Percentages can all still be used to control max and min widths. However, using percentages for padding or margin inside of a component or element should be avoided (ex. padding-right: 10%).`}</p>
<p><strong parentName="p">{`Is the spacing scale responsive?`}</strong><br />{`
No, the spacing properties themselves do not change values based on the screen size. However, it is acceptable at page breakpoints to jump a step(s) on the spacing scale to fit spacing needs.`}</p>
<p>{`Example: At 1440px `}<inlineCode parentName="p">{`padding-right: spacing05`}</inlineCode>{` but at breakpoint 768px `}<inlineCode parentName="p">{`padding-right: spacing03`}</inlineCode>{`.`}</p>
<span className="horizontal-spacer"></span>
</PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      